let pendingPin;
export const setInvestTopUpPin = (pin) => {
    pendingPin = pin;
};
export const consumeInvestTopUpPin = () => {
    const pin = pendingPin;
    pendingPin = undefined;
    return pin;
};
